export const demoIt = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Gioca Ora — Entra in Grymwyrd',
  'demo.seoDescription':
    'Fai girare il mondo, prendi un posto al tavolo, crea un eroe di Grymwyrd e tira i dadi — una guida completa al tavolo virtuale di Grymwyrd.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Il mondo di Grymwyrd',
  'demo.globe.spinningWorld': 'Girating il mondo…',
  'demo.globe.tagline': 'Un mondo horror-fantasy vivente',
  'demo.globe.arrivedHeading': 'Regione di Greywick',
  'demo.globe.heading': 'Trova il tuo posto nel crepuscolo eterno',
  'demo.globe.subheading': 'Un tavolo ti attende al cuore del mondo. Prendi il tuo posto e crea un eroe.',
  'demo.globe.enterCta': 'Scendi in Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Diventa parte della storia',
  'demo.account.subheading':
    'Crea un account gratuito per sbloccare l\'enciclopedia completa di Grymwyrd e salvare l\'eroe che stai per creare — oppure continua come ospite ed esplora subito.',
  'demo.account.createAccount': 'Crea un account',
  'demo.account.logIn': 'Accedi',
  'demo.account.continueAsGuest': 'Continua come ospite',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': 'Iniziativa',
  'demo.create.lobbyEyebrow': 'Tavolo Virtuale Grymwyrd · Lobby',
  'demo.create.heading': 'Forgia il tuo eroe',
  'demo.create.subheading': 'Un personaggio SRD 5.2.1, nato da Grymwyrd. Dagli un nome, scegli una vocazione e tira i dadi.',
  'demo.create.nameLabel': 'Nome',
  'demo.create.namePlaceholder': 'Chi diventano?',
  'demo.create.chooseCalling': 'Scegli la tua vocazione',
  'demo.create.keyAbility': 'Chiave: {ability}',
  'demo.create.abilityScores': 'Punteggi abilità',
  'demo.create.abilityScoresHint': '— clicca per tirare 3d6',
  'demo.create.rollAbilityAria': 'Tira {ability} (3d6)',
  'demo.create.keepStandard': 'Oppure tieni i 10 standard e tuffati dentro.',
  'demo.create.initiativeResult': 'Iniziativa {initiative} — tira i dadi, il tavolo si rivolge a te…',
  'demo.create.bonesTumble': 'I dadi tumolano…',
  'demo.create.rollInitiativeCta': 'Tira per l\'iniziativa e prendi il tuo posto',
  'demo.create.chooseCallingHint': 'Scegli una vocazione per prendere il tuo posto.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'Non è stato possibile preparare il tavolo',
  'demo.table.errorBody': 'Il tavolo virtuale non è disponibile in questo momento.',
  'demo.table.browseLiveTables': 'Sfoglia i tavoli attivi invece',
  'demo.table.settingTable': 'Preparando il tavolo…',
  'demo.table.connecting': 'Connessione al tavolo virtuale…',
  'demo.table.heroTable': 'Tavolo di {name}',
  'demo.table.firstTable': 'Il tuo primo tavolo',
  'demo.table.diceTrayHeading': 'Vassoio dadi',
  'demo.table.initiativeHeading': 'Iniziativa',
  'demo.table.initiativePrompt': 'Tira i dadi per stabilire l\'ordine di battaglia.',
  'demo.table.rollForInitiative': 'Tira per l\'iniziativa',
  'demo.table.vttEyebrow': 'VTT Grymwyrd',
  'demo.table.xcardTitle': 'Metti in pausa il gioco, anonimamente',
  'demo.table.xcard': 'X-Card',
  'demo.table.saveHeroTitle': 'Crea un account gratuito per salvare il tuo eroe',
  'demo.table.saveHero': 'Salva eroe',
  'demo.table.statusLive': 'Attivo',
  'demo.table.statusConnecting': 'Connessione',
  'demo.table.actionLogHeading': 'Registro azioni',
  'demo.table.recentRollsHeading': 'Tiri recenti',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Foglio Eroe',
  'demo.panel.companion': 'Compagno',
  'demo.panel.diceTray': 'Vassoio Dadi',
  'demo.panel.macros': 'Macro',
  'demo.panel.diceConsole': 'Console Dadi',
  'demo.panel.initiative': 'Iniziativa',
  'demo.panel.poll': 'Sondaggio',
  'demo.panel.recentRolls': 'Tiri Recenti',
  'demo.panel.reference': 'Riferimento',
  'demo.panel.chat': 'Chat',
  'demo.panel.handouts': 'Materiali',
  'demo.panel.safety': 'Sicurezza',
  'demo.panel.sceneAndCues': 'Scena & Segnali',
  'demo.panel.replay': 'Riproduzione',
  'demo.panel.recap': 'Riassunto',
  'demo.panel.actionLog': 'Registro Azioni',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Mischia',
  'demo.action.cast': 'Lancia',
  'demo.action.move': 'Muovi',
  'demo.action.block': 'Blocca',
  'demo.action.chooseTarget': 'Scegli un bersaglio per {action}…',
  'demo.action.controlling': 'Controllando:',
  'demo.action.cannotAct': '{label} non può agire — seleziona una folla, giocatore, veicolo o PNG.',
  'demo.action.selectActionable': 'Seleziona un oggetto azionabile per agire con esso.',
  'demo.action.cancel': 'Annulla',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Tirando l\'ordine…',
  'demo.tracker.combatant': 'Combattente {n}',
  'demo.tracker.previousTurn': 'Turno precedente',
  'demo.tracker.round': 'Round {round}',
  'demo.tracker.endCombatTitle': 'Termina lo scontro',
  'demo.tracker.end': 'Fine',
  'demo.tracker.nextTurnTitle': 'Prossimo turno',
  'demo.tracker.next': 'Prossimo',
  'demo.tracker.hitPoints': 'Punti vita',
  'demo.tracker.reduceHp': 'Riduci PV di {name}',
  'demo.tracker.raiseHp': 'Aumenta PV di {name}',
  'demo.tracker.addStatusEffect': 'Aggiungi un effetto di stato',
  'demo.tracker.removeFromOrder': 'Rimuovi dall\'ordine',
  'demo.tracker.removeFromOrderTitle': 'Rimuovi dall\'ordine',
  'demo.tracker.removeCondition': 'Rimuovi {name}',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'Il tavolo è in pausa',
  'demo.xcard.heading': 'Il tavolo è in pausa',
  'demo.xcard.body':
    'Qualcuno ha alzato la X-Card. Facciamo una pausa, senza domande e senza nomi. Quando siete pronti, continuate.',
  'demo.xcard.resume': 'Siamo pronti — continua',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Materiali',
  'demo.handouts.titlePlaceholder': 'Titolo (opzionale)',
  'demo.handouts.bodyPlaceholder': 'Una nota, un indizio, una lettura ad alta voce…',
  'demo.handouts.push': 'Invia al tavolo',
  'demo.handouts.whispered': 'Sussurrato',
  'demo.handouts.dismiss': 'Scarta materiale',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Sicurezza',
  'demo.safety.description': 'Limiti che non oltrepasseremo; veli che stenderemo. Condivisi dall\'intero tavolo, mai attribuiti.',
  'demo.safety.linesLabel': 'Limiti (no assoluto)',
  'demo.safety.veilsLabel': 'Veli (dissolvenza)',
  'demo.safety.removeItem': 'Rimuovi "{item}"',
  'demo.safety.addLinePlaceholder': 'Aggiungi un limite…',
  'demo.safety.addVeilPlaceholder': 'Aggiungi un velo…',
  'demo.safety.addLine': 'Aggiungi limite',
  'demo.safety.addVeil': 'Aggiungi velo',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Foglio Eroe',
  'demo.sheet.hp': 'PV',
  'demo.sheet.ac': 'CA',
  'demo.sheet.classLevel': '{className} · Liv 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Dispositivo compagno',
  'demo.companion.description':
    'Abbina un telefono o un tablet come secondo schermo di sola lettura — iniziativa, tiri recenti e la scena si specchiano nel dispositivo. Revoca in qualsiasi momento.',
  'demo.companion.pairDevice': 'Abbina un dispositivo',
  'demo.companion.qrAriaLabel': 'Codice QR di abbinamento compagno',
  'demo.companion.copied': 'Copiato',
  'demo.companion.copyLink': 'Copia collegamento',
  'demo.companion.revoke': 'Revoca',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Macro Dadi',
  'demo.macros.dismissError': 'Scarta errore',
  'demo.macros.newMacro': 'Nuova macro',
  'demo.macros.namePlaceholder': 'Nome (senza punti)',
  'demo.macros.labelPlaceholder': 'Etichetta pulsante (opzionale)',
  'demo.macros.save': 'Salva macro',
  'demo.macros.noDots': 'I nomi macro non possono contenere punti.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Sondaggio',
  'demo.poll.questionPlaceholder': 'Chiedi al tavolo…',
  'demo.poll.optionPlaceholder': 'Opzione {n}',
  'demo.poll.removeOption': 'Rimuovi opzione {n}',
  'demo.poll.addOption': 'Aggiungi opzione',
  'demo.poll.openPoll': 'Apri sondaggio',
  'demo.poll.live': 'Attivo',
  'demo.poll.closed': 'Sondaggio chiuso',
  'demo.poll.vote': 'Vota',
  'demo.poll.closePoll': 'Chiudi sondaggio',
  'demo.poll.startNewPoll': 'Avvia un nuovo sondaggio',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Riassunto sessione',
  'demo.recap.tagline': 'La storia del tuo tavolo, quando la polvere si è depositata.',
  'demo.recap.gathering': 'Raccogliendo la storia…',
  'demo.recap.getRecap': 'Ottieni il riassunto della sessione',
  'demo.recap.notableRolls': 'Tiri notevoli',
  'demo.recap.copied': 'Copiato!',
  'demo.recap.share': 'Condividi',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Riferimento',
  'demo.reference.searchPlaceholder': 'Cerca un mostro, incantesimo, regola…',
  'demo.reference.searchAria': 'Cerca nell\'enciclopedia per condividere',
  'demo.reference.typeToSearch': 'Digita almeno due lettere per cercare nell\'enciclopedia vivente.',
  'demo.reference.searching': 'Ricerca in corso…',
  'demo.reference.open': 'Apri {title}',
  'demo.reference.share': 'Condividi',
  'demo.reference.dismiss': 'Scarta riferimento',
  'demo.reference.backToSearch': 'Torna alla ricerca',
  'demo.reference.loadingContent': 'Caricamento contenuti…',
  'demo.reference.notOwned':
    'Non possiedi ancora questo libro. Il riferimento completo si sblocca quando lo aggiungi alla tua libreria.',
  'demo.reference.contentDown': 'Il contenuto non è disponibile in questo momento. Riprova tra poco.',
  'demo.reference.noAdditionalContent': 'Nessun contenuto aggiuntivo per questo riferimento.',
  'demo.reference.noLinkedContent': 'Nessun contenuto libro collegato per questo riferimento.',
  'demo.reference.shareToTable': 'Condividi al tavolo',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Riproduzione',
  'demo.replay.tagline': 'Ripercorri la sessione beat per beat.',
  'demo.replay.loading': 'Caricamento…',
  'demo.replay.loadReplay': 'Carica riproduzione',
  'demo.replay.loadMore': 'Carica altro',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Dadi',
  'demo.dice.dismissError': 'Scarta errore',
  'demo.dice.labelPlaceholder': 'Attacco (opzionale)',
  'demo.dice.roll': 'Tira',
  'demo.dice.rolledForReal': 'L\'ho tirato davvero',
  'demo.dice.totalPlaceholder': 'Totale (obbligatorio)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (opzionale)',
  'demo.dice.physLabelPlaceholder': 'Etichetta (opzionale)',
  'demo.dice.logPhysical': 'Registra tiro fisico',
  'demo.dice.onTable': '🎲 sul-tavolo',
  'demo.dice.private': 'Privato',
  'demo.dice.public': 'Pubblico',
  'demo.dice.rolledPrivately': 'tirato privatamente',
  'demo.dice.exploded': 'esploso',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Scena & segnali',
  'demo.scene.current': 'Scena: {scene}',
  'demo.scene.cueSuffix': '— segnale: {cue}',
  'demo.scene.noScene': 'Nessuna scena impostata',
  'demo.scene.oneShotCues': 'Segnali una tantum',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} a {x},{y}',
  'demo.map.tile': 'Casella {x},{y}',
  'demo.map.fogged': 'Offuscato',
  'demo.map.battleMap': 'Mappa di battaglia',
  'demo.map.gm': 'MG',
  'demo.map.noMap': 'Nessuna mappa',
  'demo.map.uploadedMap': 'Mappa caricata',
  'demo.map.uploadTitle': 'Carica un\'immagine di mappa come sfondo della tela',
  'demo.map.reading': 'Lettura…',
  'demo.map.upload': 'Carica',
  'demo.map.size': 'Dimensione',
  'demo.map.shrinkMap': 'Riduci mappa',
  'demo.map.growMap': 'Ingrandisci mappa',
  'demo.map.widthShort': 'L',
  'demo.map.narrowMap': 'Riduci larghezza mappa',
  'demo.map.widenMap': 'Aumenta larghezza mappa',
  'demo.map.heightShort': 'A',
  'demo.map.shortenMap': 'Riduci altezza mappa',
  'demo.map.heightenMap': 'Aumenta altezza mappa',
  'demo.map.fitTitle': 'Reimposta posizione + stendi per riempire la griglia',
  'demo.map.fit': 'Adatta',
  'demo.map.lock': 'Blocca',
  'demo.map.adjust': 'Regola',
  'demo.map.fogOn': 'Nebbia ACCESA — clicca per disabilitare',
  'demo.map.fogOff': 'Nebbia SPENTA — clicca per abilitare',
  'demo.map.fog': 'Nebbia',
  'demo.map.exitPaintTitle': 'Esci dalla modalità disegno',
  'demo.map.paintTitle': 'Disegna nebbia — clicca o trascina le caselle per rivelare/nascondere',
  'demo.map.exitPaint': 'Esci dal disegno',
  'demo.map.paint': 'Disegna',
  'demo.map.hexGridTitle': 'Griglia esagonale — clicca per quadrata',
  'demo.map.squareGridTitle': 'Griglia quadrata — clicca per esagonale',
  'demo.map.hex': 'Esagonale',
  'demo.map.zoomOut': 'Riduci zoom',
  'demo.map.zoomLevel': 'Livello zoom',
  'demo.map.zoomIn': 'Aumenta zoom',
  'demo.map.resetView': 'Reimposta visualizzazione',
  'demo.map.reset': 'Reimposta',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': 'Espandi {title}',
  'demo.dock.collapse': 'Comprimi {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'Lasciare il tavolo?',
  'demo.leave.heading': 'Lasciare il tavolo?',
  'demo.leave.body':
    'Sei nel mezzo di una partita. Questo è un tavolo ospite — se te ne vai ora, la sessione termina e il tuo eroe va perso.',
  'demo.leave.stay': 'Resta al tavolo',
  'demo.leave.leaveAnyway': 'Vattene comunque',
}
